<script lang="ts">
  import {topnav, TopnavEvents} from '@/utils/top-nav-next-custom-events';
</script>

<div class="h-full">
  <div class="flex h-full w-full">
    <button
      on:click={() => window.dispatchEvent(new Event(TopnavEvents.download))}
      class="flex w-full items-center gap-2 rounded-lg border border-rose-500 bg-rose-500 px-4 py-2 text-zinc-100 transition-all hover:bg-rose-600"
    >
      <i class="fa-solid fa-download"></i>
      Download
    </button>
  </div>
</div>
